import { useIntl } from 'react-intl';

import { ContentWrapper } from '@/components/dtcPartnerships/shared/styles';
import { StoreButton } from '@/components/ui/StoreButton';
import { useAnalytics } from '@/hooks/analytics';
import { useUserState } from '@/hooks/store';
import { useComponentDidMount } from '@/hooks/utils/useComponentDidMount';
import { getCookie } from '@/utils/cookies';
import { CALM_AUTH_METHOD, CalmAuthMethods } from '@/utils/privacyCookies';

import { SignupScreenProps } from '../shared/types';
import messages from './messages';
import { Grid, StoreButtonsWrapper, SuccessHeader, SuccessText } from './styles';
import SuccessButton from './SuccessButton';

const Success = ({
	partnerDetails: {
		id: partner_id,
		pageInfo: { messages: partnerMessages, successCTAUrl },
		category,
		user_id_descriptor,
		integration_type,
	},
}: SignupScreenProps) => {
	const { logEvent } = useAnalytics();
	const { formatMessage } = useIntl();
	const user = useUserState();
	const userLoggedInWithFb = getCookie(CALM_AUTH_METHOD) === CalmAuthMethods.Facebook;

	useComponentDidMount(() => {
		logEvent({
			eventName: 'Success : Landed',
			eventProps: {
				partner_id,
				integration_type,
				...(category && { partner_type: [category] }),
				...(user_id_descriptor && { user_id_descriptor }),
			},
		});
	});

	return (
		<Grid allowOverflow>
			<ContentWrapper>
				<SuccessHeader>{formatMessage(messages.congrats)}</SuccessHeader>
				<SuccessText>
					{formatMessage(partnerMessages?.successText ?? messages.successText, {
						breakingLine: <p />,
						bold: (...chunks) => <b>{chunks}</b>,
						login: userLoggedInWithFb
							? formatMessage(messages.successTextFacebook)
							: formatMessage(messages.successTextEmail, {
									customerEmail: user?.email,
								}),
					})}
				</SuccessText>
				<StoreButtonsWrapper>
					<StoreButton type="ios" />
					<StoreButton type="android" />
				</StoreButtonsWrapper>
				<SuccessButton successCTAUrl={successCTAUrl} partnerMessages={partnerMessages} />
			</ContentWrapper>
		</Grid>
	);
};

export default Success;
